import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { MyCarValetComponent } from './my-car-valet.component';

@NgModule({
  declarations: [MyCarValetComponent],
  imports: [
    CommonModule,
    StaticMsgModule,
    TooltipDirectiveModule,
    TableSliderModule,
    TextTooltipModule,
    TooltipDirectiveModule,
  ],
  exports: [MyCarValetComponent],
})
export class MyCarValetModule {}
